import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { Subject } from "rxjs";
import { LoginService } from "./login.service";

@Injectable({
  providedIn: "root",
})
export class StatsService {
  totalLength = 0;
  hmoNotAssign = [];
  statsForm;
  usersStats = [];
  users = [];
  HMO = ["Macabi", "Leumit", "Meuhedet", "Clalit", "Private"];
  code;
  Params;
  examsArray = [
    "OCT",
    "OCTOptic",
    "OCTMacular",
    "TOPEye",
    "FOV",
    "Fundus",
    "Pachymetry",
    "All",
  ];
  statsLoaded$ = new Subject();

  EYES = [
    "OCT",
    "OCTOptic",
    "OCTMacular",
    "TOPEye",
    "FOV",
    "Fundus",
    "Pachymetry",
    "All",
  ];

  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private loginService: LoginService,
  ) {
    this.resetForm();
  }

  resetForm() {
    this.statsForm = this.fb.group({
      All: [""],
      start: [""],
      end: [""],
      exams: [""],
      AllForms: [""],
      examsUsers: [""],
      formsUsers: [""],
      FOV: [""],
      OCT: [""],
      OCTOptic: [""],
      OCTMacular: [""],
      TOPEye: [""],
      Fundus: [""],
      Pachymetry: [""],
    });
  }

  search(params, code = null) {
    if (code) {
      this.code = code;
      this.loadData(code);
    }
    this.Params = params;
    this.http.get("/api/stats", { params: params }).subscribe((data) => {
      this.resetForm();
      if (params.end && params.start) {
        this.statsForm.get("start").setValue(params.start);
        this.statsForm.get("end").setValue(params.end);
      } else {
        this.statsForm.patchValue(data);
      }

      this.loginService.isGastro = false;
      this.loginService.isCardio = false;
      this.examsArray = this.EYES;

      this.filterData(data);
      this.statsLoaded$.next(undefined);
    });
  }

  filterByHMO(data, hmo) {
    if (!data) return [];
    var temp = data;
    this.hmoNotAssign = temp.filter((i) => i.HMO == null);
    return temp.filter((i) => i.HMO == hmo);
  }

  filterData(data) {
    this.usersStats = data["data"];
    var str;
    if (data["All"]) {
      var exams = data["All"];
      this.totalLength = data["All"].length;
      this.statsForm.get("All").setValue(exams);
      for (let i = 0; i < this.EYES.length; i++) {
        str = this.EYES[i].replace(" ", "");

        if (this.EYES[i] != "All") {
          this.statsForm.get(str).setValue(
            exams.filter((exam: any) => {
              return exam.ExamType == this.EYES[i];
            }),
          );
        }
      }
    }
  }

  exportExcel() {
    if (!this.Params) return;
    const params = new URLSearchParams(this.Params).toString();
    window.open("/api/stats/exportexcel?" + params);
  }

  loadData(code) {
    this.code = code;
    this.http
      .post("/api/print/resurection", { code: code })
      .subscribe((data) => {
        this.search(this.Params);
      });
  }

  filterExamsByPermissions(examsArray: Array<string>): Array<string> {
    const examTypes = [];

    const { OCTOptic, OCTMacular, FOV, TOPEye, Pachymetry, Fundus } =
      this.loginService.premissions;

    if (!OCTOptic && !OCTMacular) {
      examTypes.push("OCT");
    }

    if (OCTOptic) {
      examTypes.push("OCTOptic");
    }

    if (OCTMacular) {
      examTypes.push("OCTMacular");
    }

    if (FOV) {
      examTypes.push("FOV");
    }

    if (TOPEye) {
      examTypes.push("TOPEye");
    }

    if (Pachymetry) {
      examTypes.push("Pachymetry");
    }

    if (Fundus) {
      examTypes.push("Fundus");
    }

    return (examsArray = examTypes);
  }
}
